<template>
	<pui-datatable
		:modelName="modelName"
		:customizeActionAvailability="customizeActionAvailability"
		:parentModelName="parentModelName"
		:parentModel="parentModel"
		:externalFilter="externalFilter"
		:masterDetail="masterDetail"
		:readOnly="readOnly"
		:showMasterDetailFilterListBtn="true"
		:showMasterDetailFilterBtn="true"
		:showMasterDetailSortBtn="true"
		:showMasterDetailConfBtn="true"
		:modelColumnDefs="modelColumnDefs"
	></pui-datatable>
</template>

<script>
import PuiGridDetailMixin from 'pui9-mixins/PuiGridDetailMixin';
import { STATUS_DRAFT_ID } from '../../constants/imofalforms/ImoFalFormsConstants';

export default {
	name: 'imofalform6-grid',
	mixins: [PuiGridDetailMixin],
	components: {},
	data() {
		return {
			modelName: 'imofalform6',
			modelColumnDefs: {
				indarrivaldeparture: {
					render: (data) => {
						if (data === '1') {
							return this.$t('grid.imofalform6.isarrival');
						} else if (data === '2') {
							return this.$t('grid.imofalform6.isdeparture');
						} else {
							return '';
						}
					}
				},
				indtransit: {
					render: (data) => {
						if (data == '1') {
							return this.$t('grid.imofalform6.transit');
						} else if (data == '0') {
							return this.$t('grid.imofalform6.nottransit');
						} else {
							return '';
						}
					}
				},
				birthdate: {
					render: (data) => {
						return new Date(data).toLocaleDateString('es-CL');
					}
				},
				expirydate: {
					render: (data) => {
						return new Date(data).toLocaleDateString('es-CL');
					}
				}
			}
		};
	},
	methods: {
		extendFilter(filter) {
			if (this.parentModelName === 'imofalform6menu') {
				filter.rules.push({ field: 'imofalformid', op: 'eq', data: this.parentModel.imofalformid });
			}
		},
		customizeActionAvailability(actionId, parentModel) {
			if (actionId === 'puiImportAction' || actionId === 'puiExportAction') {
				return parentModel.statusid === STATUS_DRAFT_ID;
			}
		}
	}
};
</script>
